// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1bJYg","rootSuccess":"CompleteLink_rootSuccess__2I7GR","rootFailure":"CompleteLink_rootFailure__38BnH","isDisabled":"CompleteLink_isDisabled__DFRTW"};